'use strict';

var debug = require('debug');
module.exports = function turboCartoDebug (ns) {
  return debug(['turbo-carto', ns].join(':'));
};



//////////////////
// WEBPACK FOOTER
// ./~/turbo-carto/src/helper/debug.js
// module id = 104
// module chunks = 6